module.exports = __webpack_public_path__ + "img/pyr.0a64834e.svg";